import _export from "../internals/export";
import _setSymmetricDifference from "../internals/set-symmetric-difference";
import _setMethodAcceptSetLike from "../internals/set-method-accept-set-like";
var $ = _export;
var symmetricDifference = _setSymmetricDifference;
var setMethodAcceptSetLike = _setMethodAcceptSetLike;

// `Set.prototype.symmetricDifference` method
// https://tc39.es/ecma262/#sec-set.prototype.symmetricdifference
$({
  target: "Set",
  proto: true,
  real: true,
  forced: !setMethodAcceptSetLike("symmetricDifference")
}, {
  symmetricDifference: symmetricDifference
});
export default {};